import React, { useEffect, useState } from 'react';
import styles from './assets/ExacqVision.module.css';
import Cookies from 'js-cookie';
import CameraGrid from './components/CameraGrid';
import CameraSelectModal from './components/CameraSelectModal';
import Mode_Single from 'assets/OverwatchVMSModeIcons/single.png';
import Mode_Single_Selected from 'assets/OverwatchVMSModeIcons/single-selected.png';
import Mode_Double from 'assets/OverwatchVMSModeIcons/double.png';
import Mode_Double_Selected from 'assets/OverwatchVMSModeIcons/double-selected.png';
import Mode_Quad from 'assets/OverwatchVMSModeIcons/quad.png';
import Mode_Quad_Selected from 'assets/OverwatchVMSModeIcons/quad-selected.png';
import { useGetConnectedDevicesQuery } from 'services/devices/devices.api';

export default function ExacqVisionVMSWidget() {
  const {
    data: connectedDevices = [],
    isLoading: connectedDevicesLoading,
    isError: connectedDevicesError,
  } = useGetConnectedDevicesQuery();

  const MODE = {
    single: { name: 'single', numberOfOptions: 1 },
    double: { name: 'double', numberOfOptions: 2 },
    quad: { name: 'quad', numberOfOptions: 4 },
  };

  const [mode, setMode] = useState(MODE.single);
  const [cameras, _setCameras] = useState([]);
  const setCameras = (newCameras) => {
    Cookies.set('overwatch-vms', JSON.stringify(newCameras));
    _setCameras(newCameras);
  };

  const [selectCamera, setSelectCamera] = useState(null);
  const [search, setSearch] = useState('');
  const [contextMenu, setContextMenu] = useState(null);

  useEffect(() => {
    const cookie = Cookies.get('overwatch-vms');
    if (cookie) _setCameras(JSON.parse(cookie));
  }, []);

  const addCamera = (index) => setSelectCamera(index);
  const clearCamera = (index) => {
    const newCameras = [...cameras];
    if (index >= newCameras.length) return;
    newCameras[index] = null;
    setCameras([...newCameras]);
  };
  const clearAllCameras = () => setCameras([]);
  const resolveAddCamera = (camera) => {
    let newCameras = [...cameras];
    if (newCameras.length <= selectCamera) {
      const final = [];
      Array.from({ length: selectCamera + 1 }).forEach((_, index) => {
        if (index === selectCamera) final.push(camera.id);
        else if (newCameras.length > index) final.push(newCameras[index]);
        else final.push(null);
      });
      newCameras = [...final];
    } else newCameras[selectCamera] = camera.id;
    setCameras([...newCameras]);
    setSelectCamera(null);
  };
  const clearControls = () => setSearch('');
  const openContextMenu = (index) => setContextMenu(index);
  const closeContextMenu = () => setContextMenu(null);

  return (
    <div className={styles['root']}>
      {/* Header */}
      <div>
        <div className={styles['controls-container']}>
          <button onClick={() => setMode(MODE.single)}>
            <img
              src={mode.name === 'single' ? Mode_Single_Selected : Mode_Single}
              alt={mode.name === 'single' ? 'Single' : 'Single Selected'}
            />
          </button>
          <button onClick={() => setMode(MODE.double)}>
            <img
              src={mode.name === 'double' ? Mode_Double_Selected : Mode_Double}
              alt={mode.name === 'double' ? 'Double' : 'Double Selected'}
            />
          </button>
          <button onClick={() => setMode(MODE.quad)}>
            <img
              src={mode.name === 'quad' ? Mode_Quad_Selected : Mode_Quad}
              alt={mode.name === 'quad' ? 'Quad' : 'Quad Selected'}
            />
          </button>
        </div>
      </div>

      {/* Camera Grid */}
      <CameraGrid
        mode={mode}
        cameras={cameras}
        openContextMenu={openContextMenu}
        contextMenu={contextMenu}
        closeContextMenu={closeContextMenu}
        addCamera={addCamera}
        clearCamera={clearCamera}
        clearAllCameras={clearAllCameras}
        setSelectCamera={setSelectCamera}
      />

      {/* Camera Select Modal */}
      <CameraSelectModal
        open={selectCamera !== null}
        onClose={() => setSelectCamera(null)}
        search={search}
        setSearch={setSearch}
        clearControls={clearControls}
        deviceData={{ connectedDevices }}
        resolveAddCamera={resolveAddCamera}
      />
    </div>
  );
}
